var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPytorchIcon = function SvgPytorchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none",
    viewBox: "0 0 18 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4C2C",
    d: "m15.274 6.602-1.55 1.55a6.633 6.633 0 0 1 0 9.366 6.633 6.633 0 0 1-9.366 0 6.633 6.633 0 0 1 0-9.367l4.13-4.13.517-.59V.333l-6.27 6.27a8.77 8.77 0 0 0 0 12.464 8.77 8.77 0 0 0 12.465 0c3.54-3.467 3.54-9.072.074-12.465"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4C2C",
    d: "M12.176 6.16a1.18 1.18 0 1 0 0-2.36 1.18 1.18 0 0 0 0 2.36"
  })));
};
export default SvgPytorchIcon;